export const dateString = (date: Date | null) => {
  if (!date) {
    return 'Never';
  }
  return date.toLocaleString();
};

export const dateUTCString = (date: Date | null) => {
  // THIS IS HACK :) This utc_date is not really date in UTC timezone.
  // This is a Date object in local machine timezone, created with received date utc values,
  // in a sake of displaying received date in utc timezone but in localized format.
  const utc_date = date
    ? new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      )
    : null;
  return dateString(utc_date);
};
